import React, { useState } from 'react';
import ReactPaginate from 'react-paginate';
import './DetailsPopup.scss';

const DetailsPopup = ({ isOpen, details, postTitle, itemCount, onClose }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;

  if (!isOpen) return null;

  const handlePageClick = (event) => {
    const newPage = event.selected;
    setCurrentPage(newPage);
  };

  const offset = currentPage * itemsPerPage;
  const currentPageData = details.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(itemCount / itemsPerPage);

  return (
    <div className="details__container">
      <div className="details__title">
        <h2>{postTitle}</h2>
        <span className="details__item-count">{itemCount} items</span>
      </div>
      <div className="details__content">
        <table className="details__table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Selected Option</th>
              <th>Rating</th>
              <th>Comment</th>
            </tr>
          </thead>
          <tbody>
            {currentPageData.map((detail, index) => (
              <tr key={index}>
                <td>{new Date(detail.time).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}</td>
                <td>{detail.selected_option}</td>
                <td className={detail.like_status === 'like' ? 'positive' : 'negative'}> {detail.like_status === 'like' ? 'Positive' : 'Negative'}</td>
                <td>{detail.comment}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="details__footer">
        <ReactPaginate
          nextLabel="next"
          onPageChange={handlePageClick}
          pageRangeDisplayed={3}
          marginPagesDisplayed={2}
          pageCount={pageCount}
          previousLabel="previous"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination"
          activeClassName="active"
          renderOnZeroPageCount={null}
        />
        <button className="details__footer--close-btn" onClick={onClose}>Close</button>
      </div>
    </div>
       
  );
};

export default DetailsPopup;
